import { useState } from "react";

//selectors for redux :
import { useDispatch, useSelector } from "react-redux";
import { shoppingStepSlice } from "../../../../store/shoppingStepSlice.js";
import { contratStepSlice } from "../../../../store/contratStepSlice.js";
import { checkCGVSlice } from "../../../../store/checkCGVSlice.js";
import { getCGV } from "../../../../store/selectors.js";

//MUI Components
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function ContratLocation() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
    const dispatch = useDispatch();

    /* let [checked1, setChecked1] = useState(false);
    let [checked2, setChecked2] = useState(false); */

    let checked = useSelector(getCGV);
    const lang = useSelector(getLang) //global state : language

    function handleFormSubmit() {
        dispatch(shoppingStepSlice.actions.nextShoppingStep()); //go to paiement 
        //Manager Mode : 
        dispatch(contratStepSlice.actions.nextContratStep()); //go to paiement 
    }

    function handleChange(e, ind) {
        //console.log("check");
        //ind === 1 ? setChecked1(e.target.checked) : setChecked2(e.target.checked);
        dispatch(checkCGVSlice.actions.setCGV({ index: ind, check: e.target.checked }));
    }

    let textCGV = lang === "fr" ? `CONDITIONS :
    La journée de location va de 9h à 20h. Toute période de location commencée est dûe en entier. Le montant de la garantie ne peut en aucune façon couvrir une prolongation de la durée de location. En cas de rupture de contrat, aucun remboursement ne peut être effectué.
    -Il est interdit de rouler sur les plages, dans le sable et dans l'eau.
    -Le preneur s'engage à utiliser les cycles avec soin, à pourvoir à son entretien. Il n'est pas autorisé à effectuer des réparations importantes, ni à le prêter à un tiers sans l'assentiment du loueur.
    ASSURANCES RESPONSABILITE :
    Le preneur est toujours responsable des dommages corporels ou materiels causés à l'occasion de l'utilisation du cycle loué dont il a la garde(en vertu des articles 1383 et 1384 du code civil). Sauf en cas de force majeur, tout accident devra être déclaré dans les plus brefs délais, au plus tard 24h.
    ATTRIBUTION JURIDIQUE :
    En cas de litige, l'attribution expresse de compétence est faite au tribunal d'instances du domicile du loueur.
    
    En signant numériquement ce contrat, vous acceptez:
    - De vous engager à régler les frais pour les déteriorations ou vol de matériel.
    - De reconnaitre être responsable du ou des cycles en cas de vol, cas où le dépôt de garantie n'est pas restitué.
    - De régler les jours supplémentaires en cas de retard de restitution du vélo.
    - Que vos données personnelles soient utilisées uniquement par Moutchic Loisirs, et uniquement pour la gestion des locations de vélos.
    `
        :
        `TERMS :
    The rental day is from 9 a.m. to 8 p.m. Any rental period started is due in full. The amount of the guarantee cannot in any way cover an extension of the rental period. In the event of breach of contract, no refund can be made.
    -It is prohibited to ride on beaches, in sand and in water.
    -The lessee undertakes to use the cycles with care and to provide for their maintenance. He is not authorized to carry out major repairs, nor to lend it to a third party without the consent of the lessor.
    LIABILITY INSURANCE:
    The lessee is always responsible for bodily injury or material damage caused during the use of the rented cycle in his care (under articles 1383 and 1384 of the civil code). Except in cases of force majeure, any accident must be reported as soon as possible, no later than 24 hours.
    LEGAL ATTRIBUTION:
    In the event of a dispute, jurisdiction is expressly granted to the district court of the lessor's domicile.
    
    By digitally signing this contract, you agree:
    - To undertake to pay the costs for damage or theft of equipment.
    - To acknowledge being responsible for the cycle(s) in the event of theft, in case the security deposit is not returned.
    - To pay for additional days in the event of late return of the bike.
    - That your personal data is used only by Moutchic Loisirs, and only for the management of bicycle rentals.`;

    let textGarantie = lang === "fr" ? `Pour toute la durée de votre location, nous vous demandons un dépôt de garantie. La valeur de cette garantie est définie par la valeur de chaque article loué, et fonction de la quantité.
    Le dépôt de garantie peut se faire de plusieurs manières ; soit un chèque de caution (non encaissé), soit une empreinte de carte bancaire (montant non débité).
    La garantie vous sera restituée immédiatement après le retour de tous les articles loués.
    Dans certains cas, au gré de la direction, le montant global de la valeur de garantie demandée pourra être réduit pour faciliter la procédure bancaire (empreintes CB). `
        :
        `For the entire duration of your rental, we ask for a security deposit. The value of this guarantee is defined by the value of each item rented, and depending on the quantity.
    The security deposit can be done in several ways; either a deposit check (not cashed) or a bank card imprint (amount not debited).
    The guarantee will be returned to you immediately upon return of all rented items.
    In certain cases, at the discretion of management, the overall amount of the requested guarantee value may be reduced to facilitate the banking procedure (CB imprints).`;

    return (
        <div className="contrat-location">
            <div className="contrat-location-top">
                <TextField
                    className="contrat-location-top-textfield"
                    label="CGV"
                    multiline
                    rows={4}
                    fullWidth
                    inputProps={{ readOnly: true }}
                    value={textCGV}
                />
                <FormControlLabel
                    className="contrat-location-top-checkbox"
                    /* required */
                    control={<Checkbox
                        onChange={e => handleChange(e, 1)}
                        checked={checked[0]}
                    />}
                    label={translator("J'accepte les conditions générales de ventes.", lang, "cgvAccept1")}

                />

            </div>
            <div className="contrat-location-middle">

                <TextField
                    className="contrat-location-middle-textfield"
                    label={translator("Dépôt garantie", lang, "cgvGarantie")}
                    multiline
                    rows={4}
                    fullWidth
                    inputProps={{ readOnly: true }}
                    value={textGarantie}
                />
                <FormControlLabel
                    className="contrat-location-middle-checkbox"
                    /* required */
                    control={<Checkbox
                        onChange={e => handleChange(e, 2)}
                        checked={checked[1]}
                    />}
                    label={translator("J'accepte de laisser une garantie en dépôt pour la durée de ma location.", lang, "cgvAccept2")}

                />

            </div>
            <div className="contrat-location-bottom">
                <Button
                    disabled={checked[0] === false || checked[1] === false}
                    className="bouton-submit-cgv"
                    variant="contained"
                    onClick={_ => handleFormSubmit()}>
                    {translator("Valider", lang, "panierValider")}
                </Button>
            </div>


        </div>

    )
}


export default ContratLocation